import { create } from 'zustand';

interface AddOwnerModalState {
  isOpen: boolean;
  clientId?: number;
  open: (objectId: number) => void;
  close: () => void;
}

export const useAddOwnerModalStore = create<AddOwnerModalState>(set => ({
  isOpen: false,
  clientId: undefined,
  open: (clientId: number) => set({ isOpen: true, clientId }),
  close: () => set({ isOpen: false, clientId: undefined }),
}));
